import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import Layout from '@/views/layout/index'
// import _import from '@/router/_import'
const _import = require('@/router/_import_' + process.env.NODE_ENV) // 获取组件的方法


let getRouter; // 后台路由
const whiteList = ['/login', '/Home', '/Code', '/Image', '/annunciate', '/anonymity', '/signature', '/announcement','/question','/404']; // 白名单

function isIntegrationLogin(to, from, next) {
  http://localhost:8081/#/?xtoken=eyJhbGciOiJIUzI1NiJ9
  if (to.query.inspectionId) {
    localStorage.setItem('query', JSON.stringify(to.query));
  } 
  
  let xtoken = to.query.xtoken;
  if (!xtoken) { // 单点登录
    return false;
  } else {
    console.log(to);
  }

  const TokenKey = 'x-token';
  Cookies.set(TokenKey, xtoken);
  store.dispatch('IntegrationLogin', xtoken).then(() => {
    setTimeout(function() {
      next({ path: '/' });
    }, 1000);
    if (to.path === '/') {
      setTimeout(function () {
        next({ path: '/' });
      }, 1000);
    } else {
      setTimeout(function () {
        next({ path: to.path });
      }, 1000);
    }
  }).catch(() => {});
  return true;
}


router.beforeEach((to, from, next) => {
  NProgress.start();

  if (isIntegrationLogin(to, from, next)) {
    return;
  }

  if (getToken()) {

    if (to.path === '/login') {
      next({ path: '/' });
      NProgress.done();
    } else {
      if (!getRouter && (store.getters.roles || store.getters.roles.length === 0)) {

        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          getRouter = filterAsyncRouter(res.data.menus) // 过滤路由
          global.antRouter = getRouter // 将路由数据传递给全局变量，做侧边栏菜单渲染工作
          router.addRoutes(getRouter) // 动态添加路由
          next({ ...to, replace: true })
        }).catch((err) => {
          Message.error(err.message || '获取用户信息失败！');
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/' })
          }).catch(err => {
            Message.error(err.message || '注销失败');
          });
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      let loginUrl = DisciplineConfig.LOGIN_URL;
      if (loginUrl.startsWith('http')) {
        window.location.href = loginUrl;
      } else {
        next(`/Image`); // 否则全部重定向
      }
      NProgress.done()
    }
  }
});


router.afterEach(() => {
  NProgress.done()
});


// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length > 0) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })

  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/permission.js